// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__TCIoL","question":"styles_question__wnkoR"};